export * from './src/multilingual-sitetranslator-v2-site-translatable-properties-site-translator.universal.js';
